import { InjectionToken } from '@angular/core';
import { NotificationInterface } from '@evorait/pace-core';

export const NotificationInstanceToken = new InjectionToken<NotificationInterface>('NotificationInterface');
